import CustomLink from '@/bit/components/components.custom-link';
import ICON_ID from '@gcloud-npm/utils.enums.icon-id';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';

function Close({ className, handleOnClick }) {
  return (
    <div className={className}>
      <CustomLink
        role="button"
        taggingInfo={{
          componentName: `link`,
          componentVariation: 'all',
          componentContent: '',
          componentPerso: '',
          componentProduct: '',
        }}
        ariaLabel="Borrar dirección"
        onClick={handleOnClick}
      >
        <IconGlyph
          id={ICON_ID.Cerrar}
          alt="close"
          kind="m"
          layoutSize={{ width: 16 }}
          color={COLOR_DICTIONARY.GREY6}
        />
      </CustomLink>
    </div>
  );
}
export default Close;
